/**
 * @generated SignedSource<<d30c7b5a2146a0ee67469202432118f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type requestEmailConfirmationInput = {
  clientMutationId?: string | null;
};
export type RequestEmailConfirmationMutation$variables = {
  input: requestEmailConfirmationInput;
};
export type RequestEmailConfirmationMutation$data = {
  readonly requestEmailConfirmation: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message?: string;
    }>;
    readonly success: boolean | null;
  } | null;
};
export type RequestEmailConfirmationMutation = {
  response: RequestEmailConfirmationMutation$data;
  variables: RequestEmailConfirmationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "requestEmailConfirmationPayload",
    "kind": "LinkedField",
    "name": "requestEmailConfirmation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "UserError",
            "abstractKey": "__isUserError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestEmailConfirmationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestEmailConfirmationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2e0912e145c415a5d397dbde55ec785",
    "id": null,
    "metadata": {},
    "name": "RequestEmailConfirmationMutation",
    "operationKind": "mutation",
    "text": "mutation RequestEmailConfirmationMutation(\n  $input: requestEmailConfirmationInput!\n) {\n  requestEmailConfirmation(input: $input) {\n    success\n    errors {\n      __typename\n      ... on UserError {\n        __isUserError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8395ed2a9656081b39d828b45999463";

export default node;
